export class DataUtil {
    private static locale: string = "pt-BR"
    public static EXPORT_DATE = 1
    public static EXPORT_HOUR = 2
    public static EXPORT_DATE_HOUR = 3

    public static getLiteralMes(numeroMes: number) {
        if (numeroMes == null) return null
        const meses = ["janeiro", "fevereiro", "março", 'abril', 'maio', 'junho', 'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro']
        return meses[numeroMes - 1]
    }

    /**
     * 
     * @param data Informar data vinda do servidor no formato 0000-00-00 00:00:00
     * @param sufixZ Usado quando deseja formatar somente data (com hora 00:00:00)
     */
    public static getDataHoraServidor(data: String, typeExport: Number, sufixZ = "Z"): String {
        if (data == '' || data == null) return ''
        let dataTratada = data.toString().replace(" ", "T")
        let aux = new Date(dataTratada + sufixZ)
        let configLocalDateTimeString = { hour12: false, timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone}
        let date = aux.toLocaleDateString(this.locale, configLocalDateTimeString)
        let hour = aux.toLocaleTimeString(this.locale, configLocalDateTimeString)
        //hour = hour.split(":")[0] + ":" + hour.split(":")[1]

        switch (typeExport) {
            case this.EXPORT_DATE: return date
            case this.EXPORT_HOUR: return hour
            case this.EXPORT_DATE_HOUR: return date + " " + hour
            default: return date + " " + hour
        }
    }
}